import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DataTableColumn, DataTableComponent } from '../../shared/data-table/data-table.component';
import { Option } from '../../shared/data-filters/data-filter-select/data-filter-select.component';
import { defaultCriteria, TnxLoadListComponentCriteria } from '../shared/tnx-load-list-criteria.model';
import { TnxLoadStatus } from '../shared/tnx-load-status';
import { TnxLoadStatusType } from '../shared/tnx-load-status-type';
import { TnxLoadService } from '../shared/tnx-load.service';
import * as moment from 'moment';
import { Moment } from 'moment';
import { LoaderService } from '../../shared/services/loader.service';
import { finalize } from 'rxjs/operators';
import { TnxMetrics } from '../shared/tnx-metrics.model';
import { ExecutionStatus } from '../shared/execution-status';
import { ToastrService } from 'ngx-toastr';
import { ClipboardService } from '../../shared/services/clipboard.service';
import { JsonEditorService } from '../../shared/services/json-editor.service';
import { TranslateService } from '@ngx-translate/core';
import { NavigationLinkService } from '../../shared/services/navigation-link.service';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { TnxLoadEventType } from '../shared/tnx-load-event-type.model';
import { getTnxErrorContextTranslation } from '../shared/tnx-error-context';

@Component({
  selector: 'app-tnx-dashboard-load-list',
  templateUrl: './tnx-load-list.component.html',
  styleUrls: ['./tnx-load-list.component.scss']
})
export class TnxLoadListComponent implements OnInit, AfterViewInit {

  @ViewChild(DataTableComponent, { static : true })
  tnxLoadListTable: DataTableComponent;

  criteria: TnxLoadListComponentCriteria = defaultCriteria;
  statusOptions: Option[] = [
    { labelKey: 'tnx-dashboard.filters.labels.all', value: TnxLoadStatus.ALL},
    { labelKey: 'tnx-dashboard.filters.labels.created', value: TnxLoadStatus.CREATED},
    { labelKey: 'tnx-dashboard.filters.labels.updated', value: TnxLoadStatus.UPDATED},
    { labelKey: 'tnx-dashboard.filters.labels.awarded', value: TnxLoadStatus.AWARDED},
    { labelKey: 'tnx-dashboard.filters.labels.canceled', value: TnxLoadStatus.CANCELED},
    { labelKey: 'tnx-dashboard.filters.labels.expired', value: TnxLoadStatus.EXPIRED},
  ];

  filterMode: TnxLoadStatusType = TnxLoadStatusType.CUSTOM;
  FilterMode = TnxLoadStatusType;
  TnxLoadStatus = TnxLoadStatus;
  ExecutionStatus = ExecutionStatus;

  metricResults: TnxMetrics = {
    failed: 0,
    aboutToExpire: 0,
    canceled: 0,
    updated: 0
  };

  canManageLocations  = false;
  canManageCarriers   = false;

  @ViewChild('loadColumn', { static : true })
  loadColumn: TemplateRef<any>;
  @ViewChild('locationsColumn', { static : true })
  locationsColumn: TemplateRef<any>;
  @ViewChild('assignmentDeadlineColumn', { static : true })
  assignmentDeadlineColumn: TemplateRef<any>;
  @ViewChild('lastEventDateColumn', { static : true })
  lastEventDateColumn: TemplateRef<any>;
  @ViewChild('tnxAcknowledgementDateColumn', { static : true })
  tnxAcknowledgementDateColumn: TemplateRef<any>;
  @ViewChild('statusColumn', { static : true })
  statusColumn: TemplateRef<any>;
  @ViewChild('resultColumn', { static : true })
  resultColumn: TemplateRef<any>;
  @ViewChild('loadColumnTitle', { static : true })
  loadColumnTitle: TemplateRef<any>;
  @ViewChild('originAndDestinationColumnTitle', { static : true })
  originAndDestinationColumnTitle: TemplateRef<any>;
  @ViewChild('assignmentDeadlineColumnTitle', { static : true })
  assignmentDeadlineColumnTitle: TemplateRef<any>;
  @ViewChild('eventRow', { static : true })
  eventRow: TemplateRef<any>;

  columns: DataTableColumn[] = [];

  protected readonly TnxLoadEventType = TnxLoadEventType;

  protected readonly getTnxErrorContextTranslation = getTnxErrorContextTranslation;

  loadPage = (p: number, pSize: number) => {
    this.tnxLoadService.getMetrics(this.criteria)
      .subscribe(metrics => this.metricResults = metrics);
    return this.tnxLoadService.search(p, pSize, this.criteria);
  }

  constructor(
    private tnxLoadService: TnxLoadService,
    private loader: LoaderService,
    private toastr: ToastrService,
    private clipboard: ClipboardService,
    private jsonEditorService: JsonEditorService,
    private translate: TranslateService,
    private authService: AuthenticationService,
    public link: NavigationLinkService,
  ) {}

  ngOnInit() {
    this.canManageLocations = this.authService.canManageLocations();
    this.canManageCarriers  = this.authService.canManageCarriers();

    this.columns = [
      {
        name: 'load',
        displayed: true,
        translationKey: 'tnx-dashboard.table.load',
        widthCol: 154,
        template: this.loadColumn,
        sortable: false,
        customTitleTemplate: this.loadColumnTitle
      }, {
        name: 'locations',
        displayed: true,
        translationKey: 'tnx-dashboard.table.origin',
        template: this.locationsColumn,
        sortable: false,
        customTitleTemplate: this.originAndDestinationColumnTitle
      }, {
        name: 'assignmentDeadline',
        displayed: true,
        translationKey: 'tnx-dashboard.table.assignment-deadline',
        template: this.assignmentDeadlineColumn,
        sortable: false,
        customTitleTemplate: this.assignmentDeadlineColumnTitle
      }, {
        name: 'lastEventDate',
        displayed: true,
        translationKey: 'tnx-dashboard.table.last-event-date',
        template: this.lastEventDateColumn,
        sortable: false
      }, {
        name: 'tnxAcknowledgementDate',
        displayed: true,
        translationKey: 'tnx-dashboard.table.tnx-acknowledgement-date',
        template: this.tnxAcknowledgementDateColumn,
        sortable: false
      }, {
        name: 'status',
        displayed: true,
        translationKey: 'tnx-dashboard.table.status',
        template: this.statusColumn,
        sortable: false
      }, {
        name: 'result',
        displayed: true,
        translationKey: 'tnx-dashboard.table.result',
        template: this.resultColumn,
        sortable: false
      },
    ];
  }

  ngAfterViewInit(): void {
    this.resetFilters();
  }

  switchFilterMode(mode: TnxLoadStatusType) {
    if (this.filterMode === mode) {
      mode = TnxLoadStatusType.CUSTOM;
    }
    this.softResetFilters();
    switch (mode) {
      case TnxLoadStatusType.FAILURE:
        this.criteria.failedLoads = true;
        break;
      case TnxLoadStatusType.EXPIRING:
        this.criteria.aboutToExpireLoads = true;
        break;
      case TnxLoadStatusType.CANCELLED:
        this.criteria.canceledLoads = true;
        break;
      case TnxLoadStatusType.UPDATED:
        this.criteria.updatedLoads = true;
    }
    this.tnxLoadListTable.changePage(this.tnxLoadListTable.page);
    setTimeout(() => this.filterMode = mode, 0);
  }

  softResetFilters() {
    this.criteria.failedLoads = false;
    this.criteria.aboutToExpireLoads = false;
    this.criteria.canceledLoads = false;
    this.criteria.updatedLoads = false;
    this.filterMode = TnxLoadStatusType.CUSTOM;
  }

  resetFilters() {
    this.softResetFilters();
    this.criteria.status = TnxLoadStatus.ALL;
    this.criteria.loadIds = [];
    this.criteria.deliveryNumbers = [];
    delete this.criteria['lastEventAfter'];
    delete this.criteria['lastEventBefore'];
    delete this.criteria['assignmentDeadlineAfter'];
    delete this.criteria['assignmentDeadlineBefore'];
  }

  isAboutToExpire(date: Moment) {
    const now = moment();
    const limit = moment().add(3, 'hours');
    return date.isBetween(now, limit);
  }

  isSelectedLoad(loadUuid: string) {
    return this.tnxLoadListTable.isSelected(this.getTableLoad(loadUuid))
  }

  toggleDisplayEvents(loadUuid: string) {
    const tnxLoad = this.getTableLoad(loadUuid);
    if (tnxLoad.events.length === 0 && !this.isSelectedLoad(loadUuid)) {
      this.loader.startLoad();
      this.tnxLoadService.getLoadEvents(loadUuid)
        .pipe(finalize(() => this.loader.stopLoad()))
        .subscribe(events => {
          tnxLoad.events = events;
          this.tnxLoadListTable.selectMultiItem(tnxLoad);
        });
    } else {
      this.tnxLoadListTable.selectMultiItem(tnxLoad);
    }
  }

  getTableLoad(loadUuid) {
    return this.tnxLoadListTable.items.find(load => load.loadUuid === loadUuid);
  }

  copyJson(payload: string) {
    if (this.clipboard.copy(payload)) {
      this.toastr.success(this.translate.instant('copy.success'));
    } else {
      this.toastr.error(this.translate.instant('copy.error'));
    }
  }

  openContextualData(payload: string) {
    this.loader.startLoad();

    this.jsonEditorService.createJsonEditorDoc(`tnx-event-payload`, payload)
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe(result => {
        if (result.ok) {
          window.open(`http://jsoneditoronline.org/?id=${result.id}`, '_blank');
        }
      });
  }
}
